'use strict';

exports.__esModule = true;
exports.Pipeline = undefined;

var _uriRecognizer = require('./uri-recognizer');

var _uriRecognizer2 = _interopRequireDefault(_uriRecognizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global  setTimeout */

var later = window.requestIdleCallback || function (fn) {
  return setTimeout(fn, 0);
};

var Pipeline = exports.Pipeline = function () {
  function Pipeline() {
    _classCallCheck(this, Pipeline);

    this.recognizer = new _uriRecognizer2['default']();
  }

  Pipeline.prototype.put = function put(uri) {
    for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      data[_key - 1] = arguments[_key];
    }

    var result = this.recognizer.recognize(uri);
    later(function () {
      for (var i = 0; i < result.length; i++) {
        var _result$i;

        (_result$i = result[i]).handler.apply(_result$i, [result[i]].concat(data));
      }
    });
  };

  Pipeline.prototype.take = function take(uri, handler) {
    this.recognizer.add(uri, handler);
  };

  return Pipeline;
}();

var pipeline = new Pipeline();
exports['default'] = pipeline;


/*****************
 ** WEBPACK FOOTER
 ** ./~/data-pipeline/lib/pipeline.js
 ** module id = 66
 ** module chunks = 0
 **/